export default "__VITE_ASSET__D4F2Ys8R__"